// Функция для перемещения элемента внутри одной карточки
function moveElementInCard(card) {
  const elementToMove = card.querySelector('.vtl-pr-review-stars-snippet-container');
  const targetElement = card.querySelector('.product-item__quick-buy');

  if (elementToMove && targetElement && !elementToMove.classList.contains('moved')) {
    targetElement.insertAdjacentElement('afterend', elementToMove);
    elementToMove.classList.add('moved');
  }
}

function moveElementsInAllCards() {
  const cards = document.querySelectorAll('.product-item.card');
  cards.forEach(moveElementInCard);
  observer.disconnect();
}

function observeDOM() {
  const targetNode = document.body;

  const config = {
    childList: true,
    subtree: true
  };

  const observer = new MutationObserver((mutationsList) => {
    moveElementsInAllCards();
  });

  observer.observe(targetNode, config);

  setTimeout(() => {
    observer.disconnect();
  }, 10000);
}
observeDOM();
